import axios from 'axios'
import {useCallback} from 'react'
import {AuthModel, setAuth} from 'app/pages/module/auth'
import {setCookieValue} from '../helper'
import {toast} from 'react-toastify'
import {ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY} from 'sr/constants/common'
import {post} from '../axios'
import {initializeSession} from '../sessionTracker'

const handleSignIn = async (payload: any) => {
  const headers = {
    'Content-Type': 'application/json',
  }
  try {
    // Use new admin authentication endpoint
    const response = await post<any>('/admin/auth/login', payload, {
      headers,
    })
    
    // Check if 2FA is required (don't set tokens yet)
    if (response.data?.needs2FA) {
      // Return the response so the caller can handle 2FA flow
      return response
    }
    
    // Session expires after 2 hours
    const twoHoursInDays = 2 / 24;
    const sevenDays = 7;

    setCookieValue(ACCESS_TOKEN_KEY, response.data.auth.jwt, twoHoursInDays)
    setCookieValue(REFRESH_TOKEN_KEY, response.data.auth.jwt_refresh, sevenDays)
    const tokens: AuthModel = {
      api_token: response.data.auth.jwt,
      refreshToken: response.data.auth.jwt_refresh,
    }
    setAuth(tokens)
    console.log('running', response)
    
    // Initialize session tracking with 2-hour timeout
    initializeSession()
    
    // Store admin user data (not user, but admin)
    localStorage.setItem('user', JSON.stringify(response.data.admin))
    localStorage.setItem('adminRole', response.data.admin.role)
    localStorage.setItem('adminPermissions', JSON.stringify(response.data.admin.permissions))
    
    // Check if admin must change password
    if (response.data.admin.mustChangePassword) {
      toast.warning('You must change your password on first login')
    }
    
    return response
  } catch (error: any) {
    // Handle specific error codes from the API
    const errorMsg = error.response?.data?.msg;
    
    if (error.response?.status === 401) {
      // Invalid credentials (user not found or wrong password)
      toast.error('Invalid username or password');
    } else if (error.response?.status === 403) {
      // Account issues
      if (errorMsg === 'ACCOUNT.LOCKED') {
        toast.error('Your account is locked. Please try again later.');
      } else if (errorMsg === 'ACCOUNT.INACTIVE') {
        toast.error('Your account has been deactivated. Please contact support.');
      } else if (errorMsg === 'PASSWORD.EXPIRED') {
        toast.error('Your password has expired. Please reset your password.');
      } else {
        toast.error('Access denied. Please contact support.');
      }
    } else if (error.response?.data?.message) {
      toast.error(error.response.data.message);
    } else {
      toast.error('Error while logging in. Please try again.');
    }
    throw error;
  }
}

export default handleSignIn
